export const ReadPinsEventId = "im.vector.room.read_pins";

declare module "matrix-js-sdk/src/types" {
    interface RoomAccountDataEvents {
        [ReadPinsEventId]: { event_ids: string[] };
    }
}
